(() => {
  const rootSelector = '[data-eye-tests-page]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialise(root) {
    if (!root || root.dataset.motionBound === 'true') return;

    root.dataset.motionBound = 'true';
    root.classList.add('et-motion-ready');

    const heroNodes = [
      root.querySelector('.et-hero__eyebrow'),
      root.querySelector('.et-hero__title'),
      root.querySelector('.et-hero__intro'),
      root.querySelector('.et-hero__actions'),
      root.querySelector('.et-hero__media')
    ].filter(Boolean);

    heroNodes.forEach((node, index) => {
      node.classList.add('et-reveal');
      if (node.classList.contains('et-hero__media')) node.classList.add('et-reveal--image');
      node.style.setProperty('--et-delay', `${index * 70}ms`);
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => heroNodes.forEach((node) => node.classList.add('is-visible')));
    });

    const selectors = [
      '.et-glance h2',
      '.et-fact',
      '.et-thesis h2',
      '.et-thesis .et-copy',
      '.et-heading-block > *',
      '.et-step',
      '.et-before__intro > *',
      '.et-note',
      '.et-after__item',
      '.et-store',
      '.et-faq h2',
      '.et-faq__item',
      '.et-closing > .et-shell > *'
    ];

    const revealNodes = [...new Set(selectors.flatMap((selector) => [...root.querySelectorAll(selector)]))];
    revealNodes.forEach((node, index) => {
      node.classList.add('et-reveal');
      if (node.matches('.et-step, .et-store')) node.classList.add('et-reveal--editorial');
      node.style.setProperty('--et-delay', `${(index % 4) * 55}ms`);
    });

    if (!('IntersectionObserver' in window)) {
      revealNodes.forEach((node) => node.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      revealNodes.forEach((node) => observer.observe(node));
    }

    const heroMedia = root.querySelector('.et-hero__media');
    if (heroMedia && !reduceMotion.matches && window.matchMedia('(min-width: 1000px)').matches) {
      let ticking = false;
      const updateParallax = () => {
        const bounds = heroMedia.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (window.innerHeight * 0.5 - bounds.top) / window.innerHeight));
        heroMedia.style.setProperty('--et-parallax', `${Math.round(progress * 14)}px`);
        ticking = false;
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateParallax);
      };
      updateParallax();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function boot(scope = document) {
    scope.querySelectorAll(rootSelector).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
